import { api } from '@/api';
import { resolveStatus, sortByStatus } from '@/helpers/entityStatus';

export default {
  namespaced: true,
  state: {
    items: [],
    deletedItems: [],
    objects: [],
    tags: [],
    isLoading: false,
    current: {
      isLoading: false,
    },
  },
  mutations: {
    setApertures(state, items) {
      state.items = items;
    },
    setDeletedApertures(state, deletedItems) {
      state.deletedItems = deletedItems;
    },
    setApertureObjects(state, objects) {
      state.objects = objects;
    },
    setTags(state, tags) {
      state.tags = tags;
    },
    setLoading(state, loading) {
      state.isLoading = loading;
    },
    setCurrentAperture(state, data) {
      state.current = {
        ...state.current,
        ...data,
      };
    },
  },
  actions: {
    // Один список на все состояния: is_actual + is_archived вместе означают
    // выборку с корзиной, поэтому хватает одного запроса.
    getApertureObjects(store) {
      store.commit('setLoading', true);

      return api.getAperturesList({ is_actual: true, is_archived: true })
        .then(({ data }) => store.commit('setApertureObjects', sortByStatus(
          (data ?? []).map((item) => ({ ...item, status: resolveStatus(item) })),
        )))
        .finally(() => store.commit('setLoading', false));
    },

    getList(store) {
      store.commit('setLoading', true);

      const params = { is_actual: true, is_archived: false };

      return api.getAperturesList(params)
        .then(({ data }) => store.commit('setApertures', data))
        .finally(() => store.commit('setLoading', false));
    },

    getDeletedAperturesList(store) {
      store.commit('setLoading', true);

      const params = { is_actual: false, is_archived: true };

      return api.getAperturesList(params)
        .then(({ data }) => store.commit('setDeletedApertures', data))
        .finally(() => store.commit('setLoading', false));
    },

    async getAperture({ commit }, id) {
      commit('setCurrentAperture', { isLoading: true });
      const { data } = await api.getApertureById(id);
      commit('setCurrentAperture', { ...data, isLoading: false });
      return data;
    },

    archiveAperture({ dispatch }, id) {
      return api.archiveAperture(id).then(() => dispatch('getApertureObjects')).catch((error) => {
        console.error('Ошибка при архивировании апертуры:', error);
        throw error;
      });
    },

    restoreAperture({ dispatch }, id) {
      return api.restoreAperture(id).then(() => dispatch('getApertureObjects')).catch((error) => {
        console.error('Ошибка при восстановлении апертуры:', error);
        throw error;
      });
    },

    updateAperture({ state, commit }, { id, payload }) {
      return api.updateAperture(id, payload).then(({ data }) => {
        commit('setApertures', state.items.map((item) => (item.id === id ? data : item)));
        return data;
      }).catch((error) => {
        console.error('Ошибка при обновлении апертуры:', error);
        throw error;
      });
    },

    async getTags({ commit }) {
      const { data } = await api.getApertureTags();
      commit('setTags', data);
      return data;
    },

    async createTag({ dispatch }, payload) {
      await api.createApertureTag(payload);
      return dispatch('getTags');
    },

    async updateTag({ dispatch }, { id, payload }) {
      await api.updateApertureTag(id, payload);
      return dispatch('getTags');
    },

    async deleteTag({ dispatch }, id) {
      await api.deleteApertureTag(id);
      return dispatch('getTags');
    },
  },
};
